import React, { useEffect, useState } from 'react';
import { jobCardsAPI } from '../services/api';
import { History, ArrowRight } from 'lucide-react';

// Read-only audit trail of operator corrections (before -> after) for one job card.
// Drop <OperatorEditHistory jobCardId={...} /> into any job card view dialog.
const roleLabel = (r) => ({
  boring_operator: 'Boring',
  cutting_operator: 'Cutting',
  machine_operator: 'Pressing',
}[r] || r || 'Operator');

export default function OperatorEditHistory({ jobCardId }) {
  const [logs, setLogs] = useState(null); // null = loading

  useEffect(() => {
    let cancelled = false;
    if (!jobCardId) { setLogs([]); return; }
    setLogs(null);
    jobCardsAPI.getEditLogs(jobCardId)
      .then(data => { if (!cancelled) setLogs(Array.isArray(data) ? data : []); })
      .catch(() => { if (!cancelled) setLogs([]); });
    return () => { cancelled = true; };
  }, [jobCardId]);

  if (logs === null) {
    return <p className="text-xs text-gray-400 py-2">Loading edit history…</p>;
  }

  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="flex items-center gap-2 px-3 py-2 bg-gray-50 border-b">
        <History className="w-4 h-4 text-gray-500" />
        <span className="text-sm font-semibold text-gray-700">Operator Edit History</span>
        <span className="text-xs text-gray-400">({logs.length})</span>
      </div>
      {logs.length === 0 ? (
        <p className="text-xs text-gray-400 px-3 py-3">No operator corrections recorded.</p>
      ) : (
        <div className="divide-y">
          {logs.map((log) => (
            <div key={log.id} className="px-3 py-2 text-sm">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-medium text-gray-700">{log.field}</span>
                <span className="text-red-500 line-through">{log.old_value || '—'}</span>
                <ArrowRight className="w-3 h-3 text-gray-400" />
                <span className="text-green-600 font-medium">{log.new_value || '—'}</span>
              </div>
              <p className="text-xs text-gray-400 mt-0.5">
                {log.operator_name} · {roleLabel(log.operator_role)}
                {log.created_at && ` · ${new Date(log.created_at).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}`}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
